import {Component, Input} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'seo_component',
    templateUrl: './seo.component.html',
    styleUrls: ['./seo.component.css'],
    standalone: false
})
export class Seo_Component {
    @Input()
    public get metaTitel(): string {
        return this._metaTitle;
    }

    public set metaTitel(value: string) {
        this._metaTitle = value;
        this.initValues();
    }

    @Input()
    public get metaDescription(): string {
        return this._metaDescription;
    }

    public set metaDescription(value: string) {
        this._metaDescription = value;
        this.initValues();
    }

    _metaDescription: string;
    _metaTitle: string;
    metaString: string;
    maxValue: number;
    progressValue: number;
    progressColor: string;
    progressText: string;
    metaTitleTextPXLenghts: number[] = [480, 600];
    metaDescriptionTextPXLenghts: number[] = [793, 989];

    constructor(public translate: TranslateService) {
    }


    initValues() {
        this.getProgressValue();
        this.getProgressBarText();
        this.getProgressBarBackgroundColor();
    }


    getProgressValue() {
        if (this.metaTitel != undefined) {
            this.metaString = this.metaTitel
            this.maxValue = this.metaTitleTextPXLenghts[1]
        } else {
            this.metaString = this.metaDescription
            this.maxValue = this.metaDescriptionTextPXLenghts[1]
        }
        const textLength = this.metaString?.length;
        if (textLength <= this.maxValue) {
            this.progressValue = (textLength / this.maxValue) * 100;
        } else {
            this.progressValue = 100;
        }
    }


    getProgressBarBackgroundColor() {

        if (this.metaTitel != undefined) {
            let textLenght = this.getTextPXWidth(this.metaTitel, '20px Arial');
            if (textLenght <= this.metaTitleTextPXLenghts[0]) {
                this.progressColor = 'olivedrab';
            } else if (textLenght <= this.metaTitleTextPXLenghts[1]) {
                this.progressColor = 'orange';
            } else {
                this.progressColor = 'firebrick';
            }
        } else {
            let textLenght = this.getTextPXWidth(this.metaDescription, '14px Arial');
            if (textLenght <= this.metaDescriptionTextPXLenghts[0]) {
                this.progressColor = 'olivedrab';
            } else if (textLenght <= this.metaDescriptionTextPXLenghts[1]) {
                this.progressColor = 'orange';
            } else {
                this.progressColor = 'firebrick';
            }
        }
    }

    getProgressBarText() {

        if (this.metaTitel != undefined) {
            let textLenght = this.getTextPXWidth(this.metaTitel, '20px Arial');
            var scaledWidth = this.getScaledWidth(textLenght, this.metaTitleTextPXLenghts[1]);
            if (textLenght <= this.metaTitleTextPXLenghts[0]) {
                this.progressText = this.translate.instant("MetaTitelProgressTextGut",
                {
                    scaledWidth: scaledWidth,
                    metaTitellength: this.metaTitel.length,
                });
            } else if (textLenght <= this.metaTitleTextPXLenghts[1]) {
                this.progressText = this.translate.instant("MetaTitelProgressTextRisky",
                    { scaledWidth: scaledWidth,
                        metaTitellength: this.metaTitel.length,
                    }
                    );
            } else {
                this.progressText = this.translate.instant("MetaTitelProgressTextBad",
                    { scaledWidth: scaledWidth,
                        metaTitellength: this.metaTitel.length,
                    }
                );
            }
        } else {
            let textLenght = this.getTextPXWidth(this.metaDescription, '14px Arial');
            var scaledWidth = this.getScaledWidth(textLenght, this.metaDescriptionTextPXLenghts[1]);
            if (textLenght <= this.metaDescriptionTextPXLenghts[0]) {
                this.progressText = this.translate.instant("MetaDescrProgressTextGut",
                    {
                        scaledWidth: scaledWidth,
                        metaDescrlength: this.metaDescription.length,
                    });
            } else if (textLenght <= this.metaDescriptionTextPXLenghts[1]) {
                this.progressText = this.translate.instant("MetaDescrProgressTextRisky",
                    {
                        scaledWidth: scaledWidth,
                        metaDescrlength: this.metaDescription.length,
                    });
            } else {
                this.progressText = this.translate.instant("MetaDescrProgressTextBad",
                    {
                        scaledWidth: scaledWidth,
                        metaDescrlength: this.metaDescription.length,
                    });
            }
        }
    }

    getTextPXWidth(text: string, font: string): number {
        const canvas =
            (this.getTextPXWidth as any)._canvas ||
            ((this.getTextPXWidth as any)._canvas = document.createElement('canvas'));

        const context = canvas.getContext('2d');
        if (!context) {
            return 0;
        }

        context.font = font;
        const metrics = context.measureText(text);
        return Math.round(metrics.width);
    }

    getScaledWidth(currentNumber: number, maxNumber: number): number {
        return Math.round((currentNumber / maxNumber) * 100);
    }
}
